// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import './MainMobileFooterItem.scss';

type Props = {
  name: string,
  to?: string,
  href?: string,
  active?: boolean,
  onClick?: () => void,
};

const MainMobileFooterItem = ({ to, name, active, onClick, href }: Props) => {
  const privacy = name === '개인정보처리방침';

  if (href) {
    return (
      <li className={cx('MainMobileFooterItem', { active })}>
        <a href={href} target="_blank" rel="noopener noreferrer">
          <div className="item-name">{name}</div>
        </a>
      </li>
    );
  }

  return to ? (
    <li className={cx('MainMobileFooterItem', { active, privacy })}>
      <Link to={to}>
        <div className={cx('item-name', { privacy })}>{name}</div>
      </Link>
    </li>
  ) : (
    <li className={cx('MainMobileFooterItem', { active })}>
      <div className="item-name" onClick={onClick}>
        {name}
      </div>
    </li>
  );
};

export default MainMobileFooterItem;



// WEBPACK FOOTER //
// ./src/components/main/MainMobileFooterItem/MainMobileFooterItem.js